import { InputHelperText } from '@/shared/components/input-helper-text'
import { Input } from '@material-tailwind/react'
import { getIn, useFormikContext } from 'formik'

export const InternationalPhoneInput = ({
  name,
  label = 'Teléfono',
  value,
  onChange,
  error,
  helperText,
  ...props
}) => {
  const { values, errors, handleChange, setFieldTouched, validateField } = useFormikContext()
  const fieldValue = value ?? getIn(values, name) ?? ''
  const fieldError = error ?? Boolean(getIn(errors, name))
  const fieldHelperText = helperText ?? getIn(errors, name)

  const handlePhoneChange = async (event) => {
    if (onChange) {
      await onChange(event)
    } else {
      handleChange(event)
    }

    await setFieldTouched(name, true, false)
    await validateField(name)
  }

  return (
    <div>
      <Input
        name={name}
        label={label}
        value={fieldValue}
        onChange={handlePhoneChange}
        error={fieldError}
        {...props}
      />
      <InputHelperText label={fieldHelperText} color='red' />
    </div>
  )
}
